import CollapsibleSection from "components/Section";
import { Button } from "components/Button";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import TextValue from "components/TitleValue";
import { useTranslation } from "react-i18next";
import {
  TSubscriberWaterMeter,
  TWaterMeter,
  TWaterMeterReadingData,
} from "types/dto";

import { MapLocationPicker_v2 } from "components/MapLocationPicker_v2";
import { useURLTools } from "utils/URLtools";

type TProps = {
  title?: string;
  data?: TWaterMeter;
  isLoading?: boolean;
};
export const MeterLocationMap = (props: TProps) => {
  const { data, isLoading, title } = props;

  const { t } = useTranslation();
  const { navigateWithQueryParams } = useURLTools();

  const apartmentId = data?.currentInstallation?.apartmentId;

  return (
    <CollapsibleSection
      title={t("meterLocation")}
      collapsible={false}
      isLoading={isLoading}
      skeleton="map"
      className={"h-full flex flex-col"}
      contentClassName={"flex-1 flex flex-col min-h-0"}
    >
      {/* Map fills all the height MeterInfo dictates; the action row stays pinned
          to the bottom so both cards in the row end flush. */}
      <div className={"w-full flex-1 min-h-[278px]"}>
        {data?.currentInstallation ? (
          <MapLocationPicker_v2
            initialMarker={{
              lat: data.currentInstallation.latitude,
              lng: data.currentInstallation.longitude,
            }}
            disabledLocationPick
            coordinateFields={"readonly"}
          />
        ) : (
          <div className={"w-full h-full flex items-center justify-center"}>
            <p className={"text-sm text-gray-90 font-bold "}>
              {t("meterNotInstalled")}
            </p>
          </div>
        )}
        {/*<Map_openLayers className={"w-full h-full"} />*/}
      </div>

      {apartmentId && (
        <div className={"w-full flex items-center justify-end mt-4"}>
          <Button
            variant={"outlined"}
            icon={"MdApartment"}
            onClick={() =>
              navigateWithQueryParams(
                `/dashboard/apartments/details/${apartmentId}`,
                [],
                { openInNewTab: true }
              )
            }
          >
            {t("goToApartmentDetails")}
          </Button>
        </div>
      )}
    </CollapsibleSection>
  );
};
